import React, { useState, useEffect } from 'react';
import { GradientDisplay } from './components/GradientDisplay';
import { Navbar } from './components/Navbar';
import { KeyboardControls } from './components/KeyboardControls';
import { MobileControls } from './components/MobileControls';
import { Footer } from './components/Footer';
import { generateNewGradient } from './utils/gradientUtils';
import { ThemeProvider } from './context/ThemeContext';
import { useTheme } from './context/ThemeContext';
import { playPopSound } from './utils/soundUtils';

function AppContent() {
  const { isDarkMode } = useTheme();
  const [gradient, setGradient] = useState(generateNewGradient());
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.code === 'Space') {
        event.preventDefault();
        setGradient(generateNewGradient());
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, []);

  const handleGenerateNew = () => {
    playPopSound('strong'); // Play sound effect
    setGradient(generateNewGradient());
  };

  if (isLoading) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${
        isDarkMode ? 'bg-[#1C1C1C]' : 'bg-gray-50'
      } transition-colors duration-300`}>
        <div className="animate-pulse flex flex-col items-center gap-4">
          <div className="w-32 h-32 rounded-2xl bg-gradient-to-r from-gray-200 to-gray-300 dark:from-gray-800 dark:to-gray-700" />
          <div className="h-4 w-48 bg-gray-200 dark:bg-gray-800 rounded" />
        </div>
      </div>
    );
  }

  return (
    <div className={`min-h-screen flex flex-col ${
      isDarkMode ? 'bg-[#1C1C1C]' : 'bg-gray-50'
    } transition-colors duration-300`}>
      <Navbar />
      
      <main className="flex-1 pt-24 px-4">
        <GradientDisplay gradient={gradient} />
        <div className="mt-8 mb-16 md:mb-24">
          <KeyboardControls />
        </div>
      </main>

      <div className="hidden md:block">
        <Footer />
      </div>
      <div className="md:hidden pb-24">
        <Footer />
      </div>
      <MobileControls onGenerateNew={handleGenerateNew} />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;